module.exports = __webpack_public_path__ + "img/C户型1.03e1f9d0.png";